import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../constants/content";

export const FloatingCall = () => (
    <motion.div
        initial={{ y: 90 }}
        animate={{ y: 0 }}
        transition={{ delay: 1.8, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="fixed bottom-0 inset-x-0 z-50 sm:hidden p-3 bg-gradient-to-t from-white via-white/90 to-transparent"
    >
        <a
            href={PHONE_TEL}
            data-testid="floating-mobile-call-button"
            className="flex items-center justify-center gap-3 rounded-md bg-[#FF3B30] py-4 font-display font-extrabold text-lg text-white uppercase tracking-wide shadow-[0_8px_32px_rgba(255,184,0,0.35)] active:scale-[0.98] transition-transform"
        >
            <Phone className="h-5 w-5" strokeWidth={2.8} />
            Call {PHONE_DISPLAY}
        </a>
    </motion.div>
);
